import { SimpleGrid } from "@chakra-ui/react";
import { Button } from "../ui/button";
import { EmptyState } from "../ui/empty-state";
import { HiColorSwatch } from "react-icons/hi";
import { FavoriteItem } from "@/types/favorites";
import FavoriteItemCard from "./FavoriteItemCard";
import { I18nLink } from "../i18n/I18nLink";
import { useTranslations } from "next-intl";
import React from "react";

interface Props {
  items: FavoriteItem[];
}

export default function FavoriteItemList({ items }: Props) {
  const t = useTranslations();

  if (!items || items.length === 0) {
    return (
      <EmptyState
        icon={<HiColorSwatch />}
        title={t('no_products')}
        description={t('try_change_filters_or_back')}
      >
        <I18nLink href="/" passHref>
          <Button borderRadius={"none"}>{t('go_to_mainpage')}</Button>
        </I18nLink>
      </EmptyState>
    );
  }

  const isSingle = items.length === 1;

  return (
    <SimpleGrid
      columns={{ base: 2 }}
      gap={0}
      borderLeft="1px solid var(--chakra-colors-stroke)"
      borderTop={isSingle ? undefined : "1px solid var(--chakra-colors-stroke)"}
    >
      {items.map((item, idx) => (
        <FavoriteItemCard
          key={item.id}
          item={item}
          boxSizing="border-box"
          borderRight="1px solid var(--chakra-colors-stroke)"
          borderBottom="1px solid var(--chakra-colors-stroke)"
          borderTop={isSingle ? "1px solid var(--chakra-colors-stroke)" : undefined}
        />
      ))}
    </SimpleGrid>
  );
}